// pages/PortraitCompare/index.tsx
import React from 'react';
import { BASEURL } from "@api/baseUrl"
import {Button, Drawer, Input, Space} from "antd"
import { useRef, useState } from "react"
import { useHistory } from "react-router-dom"
import { columnsFn } from "./data"
import ProTable, { ActionType } from "@ant-design/pro-table"
import { checkGetCardOperatorList } from '@api/product';
import { productApi } from '@utils/util';
import { PROCODE_PORTRAITCOMPARE } from '@utils/enum';
import { ExportButton } from '@components/index';
import { photomatch } from "@api/product/identityCheck";
import ProForm from "@ant-design/pro-form";
import { UserOutlined, IdcardOutlined, PictureOutlined } from "@ant-design/icons";
import { ImageUploadPanel } from "@components/MyProduct/Common/ImageUploadPanel";
import {useImageCheck} from "@components/MyProduct/Common/useImageCheck";

// 接口请求的 api 层
const getApi = productApi(checkGetCardOperatorList)

// 在线发送
export default () => {
    const history = useHistory()
    const formRef = useRef()
    const otherParams = { productCode: PROCODE_PORTRAITCOMPARE }
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
    const [modalProps, setModalProps] = useState({ visible: false, title: '新增', params: {} })
    const ref = useRef<ActionType>(null);
    const [uploadVisible, setUploadVisible] = useState(false);

    const operate = async (type: any, record: any) => {
        // operate 函数为增删改查需要处理的业务
    }

    const getListApi = async (params: any, sorter: any, filter: any) => {
        const { data } = await getApi({ ...params }, false)
        const { values, total } = data || {}
        return {
            data: values || [],
            success: true,
            total
        }
    }

    const columns = columnsFn(operate)

    const getQueryParams = () => ({
        // @ts-ignore
        ...formRef.current?.getFieldsFormatValue(),
        ...otherParams
    })

    const reFresh = () => {
        // @ts-ignore
        ref.current?.clearSelected()
        ref.current?.reload()
    }

    // 自定义确认内容
    const createPortraitConfirmContent = (params: {
        values: any;
        imageInfo?: any;
        fileList?: any;
        imageType: any;
        formatFileSize: (bytes: number) => string;
    }) => {
        const { values, imageInfo, formatFileSize } = params;

        return (
            <div>
                <div>即将比对的个人信息：</div>
                <div style={{ marginTop: 8 }}>
                    <strong>姓名：</strong>{values.name}
                </div>
                <div style={{ marginTop: 4 }}>
                    <strong>身份证号：</strong>{values.idNo}
                </div>
                {imageInfo && (
                    <>
                        <div style={{ marginTop: 8 }}>
                            <strong>图片文件：</strong>{imageInfo.name}
                        </div>
                        <div style={{ marginTop: 4, color: '#666', fontSize: 12 }}>
                            文件大小：{formatFileSize(imageInfo.size)}
                        </div>
                    </>
                )}
                <div style={{ marginTop: 8, color: '#faad14' }}>
                    启动后将不支持取消，请确认！
                </div>
            </div>
        );
    };

    const OnlineRequest = ({ onOk }: { onOk?: () => void }) => {
        const [form] = ProForm.useForm();
        const [imageType, setImageType] = useState<'BASE64'>('BASE64');

        const {
            fileList,
            loading,
            imagePreview,
            imageInfo,
            customRequest,
            startCheck,
            removeImage,
            formatFileSize,
        } = useImageCheck({
            request: async (params: any) => {
                return photomatch(params);
            },
            onSuccess: () => {
                onOk?.();
                reFresh();
            },
            successMessage: '提交成功，请稍后刷新页面查看比对结果',
            needName: true,
            needIdNo: true,
            createConfirmContent: createPortraitConfirmContent,
        });

        // 自定义提交按钮
        const CustomSubmitter = () => {
            const nameValue = ProForm.useWatch('name', form);
            const idNoValue = ProForm.useWatch('idNo', form);

            return (
                <div style={{ textAlign: 'center', marginTop: 24 }}>
                    <Button
                        type="primary"
                        size="large"
                        style={{ width: 200 }}
                        onClick={() => startCheck({
                            form,
                            imageType,
                        })}
                        loading={loading}
                        disabled={fileList.length === 0 || !nameValue || !idNoValue}
                    >
                        开始验证
                    </Button>

                    <div style={{ marginTop: 8, fontSize: 12, color: '#999' }}>
                        {fileList.length && nameValue && idNoValue
                            ? '信息已准备就绪'
                            : '请填写身份信息并上传图片'}
                    </div>
                </div>
            );
        };

        return (
            <div style={{ padding: '0 20px' }}>
                <ProForm
                    form={form}
                    layout="horizontal"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 16 }}
                    submitter={{
                        render: () => <CustomSubmitter />
                    }}
                    initialValues={{}}
                >
                    {/* 姓名 */}
                    <ProForm.Item
                        label="姓名"
                        name="name"
                        rules={[
                            { required: true, message: '请输入姓名' },
                            { max: 50, message: '姓名不能超过50个字符' }
                        ]}
                    >
                        <Input
                            placeholder="请输入姓名"
                            prefix={<UserOutlined style={{ color: '#999' }} />}
                            allowClear
                        />
                    </ProForm.Item>

                    {/* 身份证号 */}
                    <ProForm.Item
                        label="身份证号"
                        name="idNo"
                        rules={[
                            { required: true, message: '请输入身份证号' },
                            {
                                pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                                message: '请输入正确的身份证号'
                            }
                        ]}
                    >
                        <Input
                            placeholder="请输入身份证号"
                            prefix={<IdcardOutlined style={{ color: '#999' }} />}
                            allowClear
                            maxLength={18}
                        />
                    </ProForm.Item>

                    {/* 图片上传区域 */}
                    <ProForm.Item
                        label="人像图片"
                        name="image"
                        rules={[{ required: true, message: '请上传人像图片' }]}
                        validateStatus={fileList.length ? 'success' : 'error'}
                        help={!fileList.length ? '请上传有效的人像图片' : ''}
                    >
                        <ImageUploadPanel
                            fileList={fileList}
                            imagePreview={imagePreview}
                            imageInfo={imageInfo}
                            onUpload={customRequest}
                            onRemove={removeImage}
                            accept="image/*"
                            buttonText="选择图片文件"
                            formatFileSize={formatFileSize}
                            imageType={imageType}
                        />
                    </ProForm.Item>
                </ProForm>

                {/* 使用说明 */}
                <div style={{
                    marginTop: 24,
                    padding: 16,
                    border: '1px solid #e8e8e8',
                    borderRadius: 6,
                    backgroundColor: '#f9f9f9'
                }}>
                    <div style={{ fontWeight: 'bold', marginBottom: 12, color: '#333' }}>
                        使用说明
                    </div>
                    <div style={{ fontSize: 13, lineHeight: 1.8, color: '#666' }}>
                        <div>🖼️ <strong>人像比对验证模式：</strong></div>
                        <div>1. 输入待比对的姓名和身份证号信息</div>
                        <div>2. 点击”选择图片文件”上传人像照片</div>
                        <div>3. 支持 JPG、PNG、BMP、GIF 格式，单个文件最大 2MB</div>
                        <div>4. 系统会自动检测图片尺寸和基本信息</div>
                        <div>5. 上传后可预览图片信息，可随时移除重新上传</div>
                        <div style={{ marginTop: 12 }}>
                            ⚠️ <strong>重要注意事项：</strong>
                        </div>
                        <div>• 请确保姓名和身份证号信息准确无误</div>
                        <div>• 上传的人像图片应清晰可见，正面免冠</div>
                        <div>• 图片中人脸部分应占据足够比例</div>
                        <div>• 确保图片光线充足，避免过暗或过曝</div>
                        <div>• 避免使用美颜、滤镜处理过的照片</div>
                        <div>• 人像比对验证用于核实身份信息的真实性</div>
                        <div>• 提交成功后，比对结果会显示在调用明细中</div>
                        <div>• 可在表格中查看历史记录并导出结果</div>
                        <div>• 该调用会产生一定费用,请确认余额充足</div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <ProTable<any>
                style={{ flex: 1, overflow: 'scroll' }}
                scroll={{ x: 1300 }}
                columns={columns}
                params={otherParams}
                request={getListApi}
                formRef={formRef as any}
                options={{ reload: false, density: false, setting: false }}
                toolbar={{
                    actions: [
                        <ExportButton
                            key="export"
                            type='primary'
                            action={`${BASEURL}/web/product/exportCardOperatorList`}
                            param={getQueryParams}
                            btnText="导出"
                        />,
                        <Button
                            key="online"
                            type="primary"
                            onClick={() => setUploadVisible(true)}
                            style={{ marginLeft: 8 }}
                        >
                            <Space>
                                <span>在线验证</span>
                            </Space>
                        </Button>,
                    ],
                }}
                rowKey="tiId"
                pagination={{ defaultPageSize: 10, showSizeChanger: true, showQuickJumper: true }}
                actionRef={ref as any}
                search={{
                    optionRender: (searchConfig, formProps, dom) => [...dom.reverse()]
                }}
            />
            <Drawer
                title={
                    <Space>
                        <PictureOutlined />
                        <span style={{ fontSize: 16, fontWeight: 'bold' }}>人像比对验证</span>
                    </Space>
                }
                open={uploadVisible}
                width={800}
                onClose={() => {
                    setUploadVisible(false);
                }}
                destroyOnClose
            >
                <OnlineRequest
                    onOk={() => {
                        setUploadVisible(false);
                        setTimeout(() => {
                            reFresh();
                        }, 1000);
                    }}
                />
            </Drawer>
        </>
    );
}